import { Grid, Row, Col } from 'rsuite'
import React from 'react'

/**
 * CustomGrid displays a list of components in a responsive grid.
 * @param {Object} props
 * @param {React.ReactNode[]} props.items - List of components to display
 * @param {React.ReactNode} props.preComponent - Component to display before the grid
 * @param {React.ReactNode} props.postComponent - Component to display after the grid
 */
const CustomGrid = ({ items, preComponent, postComponent }) => {
  const validItems = Array.isArray(items)
    ? items.map((item, idx) => {
        if (!React.isValidElement(item)) {
          console.error(`CustomGrid: Item at index ${idx} is not a valid React element. Received:`, item)
          return (
            <div key={idx} style={{ color: 'red' }}>
              Invalid grid item
            </div>
          )
        }
        return item
      })
    : []

  return (
    <Grid fluid>
      <Row style={{ marginLeft: -15, marginRight: -15 }}>
        {preComponent && (
          <Col xs={24} style={{ padding: 10 }}>
            {preComponent}
          </Col>
        )}
        {validItems.map((item, idx) => {
          return (
            <Col key={idx} xs={12} sm={12} md={6} lg={6} style={{ padding: 10 }}>
              {item}
            </Col>
          )
        })}
        {postComponent && (
          <Col xs={24} style={{ padding: 10 }}>
            {postComponent}
          </Col>
        )}
      </Row>
    </Grid>
  )
}

export default CustomGrid
